import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Brand, BrandCollection } from '../interfaces';
import { ApiService } from './api.service';

export type BrandFilters = {
  nom?: string
  code?: string
  order_by?: string;
  order?: string;
  page?: number;
  size?: number;
  fields?: {
    marques?: string;
  }
  [x: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class BrandService extends ApiService {

  public get(id: string | number, filters: BrandFilters = {}): Observable<Brand> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<Brand>(`${this.apiUrl}/marques/${id}${queryString}`)
  }

  public getCollection(filters: BrandFilters = {}): Observable<BrandCollection> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<BrandCollection>(`${this.apiUrl}/marques/${queryString}`)
  }

  public post(data: Partial<Brand>, filters: BrandFilters = {}): Observable<Brand> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.post<Brand>(`${this.apiUrl}/marques/${queryString}`, data)
  }

  public patch(id: string | number, data: Partial<Brand>, filters: BrandFilters = {}): Observable<Brand> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.patch<Brand>(`${this.apiUrl}/marques/${id}${queryString}`, data)
  }

  public delete(id: string | number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/marques/${id}`)
  }
}
